module.exports = __webpack_public_path__ + "fonts/fa-brands-400.27a2c73e.woff";